import AlertAccent from '../../components/AlertAccent';
import * as React from 'react';

const EmailAlert = ({ isForeignMail }) => {
  return (
    <AlertAccent
      classContainer={'mb-4'}
      title="Пожалуйста, изменитe email!"
      text="Ваш текущий адрес относится к иностранному домену. В системе допускается использование только российских доменов (например, .ru, .рф). Пожалуйста, укажите email в российском домене, чтобы продолжить работу и корректно получать уведомления"
      showAlert={isForeignMail}
    />
  );
};

export default EmailAlert;
